class AjaxContent {
  constructor() {
    this.elContainer = Helper.getElements('.ajax-content');
    if (this.elContainer.length <= 0) return;
    this.boundInit = this.init.bind(this);
    window.addEventListener('scroll', this.boundInit);
  }

  init() {
    this.elContainer.forEach( container => {
      this.initContainer(container);
    });
    window.removeEventListener('scroll', this.boundInit);
  }

  initContainer(container) {
    let data = {
      targetUrl: container.dataset.url !== false ? container.dataset.url : '',
      targetId: container.dataset.id !== false ? container.dataset.id : '',
      callbackFn: container.dataset.callback !== false ? container.dataset.callback : false,
    }

    jQuery.ajax({
      url: data.targetUrl,
      success: result => {
        let temp = $(result);
        let target = temp.find(data.targetId);

        if (!target) {
          console.log('AjaxContent - No results found');
          return;
        }

        container.appendChild(target[0]);

        if (data.callbackFn) {
          eval(data.callbackFn);
        }
      }
    });
  }
}